// import { EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons';

import Sidebar from "../../Components/Sidebar";

import addcircle from "../../assest/add-circle.png";
import CampaignsTable from "../../Components/Table/CampaignsTable";
import { useLocation, useNavigate } from "react-router-dom";
import overview from "../../assest/dashboard b.png";
import targetgroup from "../../assest/2.png";
import targetuser from "../../assest/dashboard a.png";
import { useEffect, useState } from "react";

import deletebtn from "../../assest/newButton.png";
import DeleteModal from "../../Components/Modal/Deletemodal";
import DeleteNotification from "../../Components/Notification/DeleteNotification";
import UpdateNotification from "../../Components/Notification/UpdateNotification";

import ChartCard from "../../Components/Charts/CompaignClickGraph";
import ChartCardlogin from "../../Components/Charts/Compaignislogin";
import EditCampaign from "../../Components/Modal/EditCampaign";
import { useSelector } from "react-redux";
import { Input } from "antd";
import { getCampaign } from "../../redux/actions/campaignaction";
import Button from "react-bootstrap/Button";
import { IoReorderThree } from "react-icons/io5";

const MyCampaigns = () => {
  const { Search } = Input;

  useEffect(() => {
    const fetchData = async () => {
      try {
        let organizationid = localStorage.getItem("organizationid");
        let page = 1;
        let payload = { organizationid, page };
        // Await each function one after the other
        await getCampaign(payload);

      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData(); // Call the fetchData function
  }, []);

  const allcampaign = useSelector(
    (state) => state?.campaignReducer?.Allcampaign
  );

  const userdetails = useSelector((state) => state?.Auth?.userDetails?.data);

  const navigation = useNavigate();
  const location = useLocation();
  const currentRoute = location.pathname;

  const [selectedCard, setSelectedCard] = useState(null);
  const [multicampaign, setMultiCampagin] = useState([]);

  const handleCardClick = (cardIndex) => {
    setSelectedCard(cardIndex);
    setColornumber(cardIndex);
  };

  const [selectedCheckboxes, setSelectedCheckboxes] = useState([]);

  const [modalVisible, setModalVisible] = useState(false);
  const [editmodalVisible, setEditModalVisible] = useState(false);
  const [editnotificationmodal, setEditNotificationmodal] = useState(false);
  const [deletenotificationmodal, setDeleteNotificationmodal] = useState(false);
  const [colornumber, setColornumber] = useState(null);
  const [, setDeletecomp] = useState(null);
  const [selectAll, setSelectAll] = useState(false);
  const [show, setShow] = useState(false);
  const handleShow = () => setShow(true);

  const handleCheckboxChange = (e, record) => {
    const { checked } = e.target;


    // Update the selected checkboxes state
    setSelectedCheckboxes((prevSelected) => {
      let updatedSelected = checked
        ? [...prevSelected, record._id] // Add record to the selected checkboxes
        : prevSelected.filter((key) => key !== record._id); // Remove record from selected checkboxes

      // Update the multiCampagin state
      // Here, we are adding or removing the record name based on whether the checkbox is checked
      setMultiCampagin(updatedSelected.map((id) => record.name)); // Update multiCampagin with the selected names

      return updatedSelected;
    });
  };

  const handleSelectAllChange = () => {
    if (selectAll) {
      // If selectAll is true, deselect all
      setSelectedCheckboxes([]);
    } else {
      // If selectAll is false, select all campaigns

      setSelectedCheckboxes(
        allcampaign?.usercampaign?.map((campaign) => campaign._id)
      );
      setMultiCampagin(
        allcampaign?.usercampaign?.map((campaign) => campaign.name)
      );
    }
    setSelectAll(!selectAll);
  };

  const onSearch = async (value) => {
    try {
      let combinedSearch = value;

      if (multicampaign.length > 0) {
        combinedSearch += ", " + multicampaign.join(", ");
      }

      let payload = {
        organizationid: userdetails.organizationid,
        search: combinedSearch,
      };

      await getCampaign(payload);
    } catch (error) {
      console.log("error", error);
    }
  };

  return (
    <div className='dashboard'>
      <Sidebar show={show} setShow={setShow} />
      <div className='dashboard-right-side'>
        <div className='headerbox'>
          <div className='d-flex gap-2 align-items-center'>
            <Button
              className='d-block d-lg-none bg-transparent text-dark border border-0'
              onClick={handleShow}
            >
              <IoReorderThree size={30} />
            </Button>
            <div className='headertext'>My Campaigns</div>
          </div>
          <div
            onClick={() => navigation("/campaignflow")}
            className='createcampaignbutton flex items-center space-x-2'
          >
            <img alt='' className='createcampaignimg w-6 h-6' src={addcircle} />
            <span className='hidden md:inline'>Create New Campaign</span>
          </div>
        </div>

        <div className='row mt-3'>
          <div className='col-sm-12 col-md-6 col-lg-4 mb-4'>
            <div className='d-flex justify-content-between pt-4 statsbox px-3'>
              <div className='statsheading'>
                <p className='statSize mb-1 text-muted'>Users Smished</p>
                <h1 className='mb-0'>{allcampaign?.totalusers}</h1>
              </div>
              <div className='text-end'>
                <img className='statsimg' src={overview} alt='' />
              </div>
            </div>
          </div>
          <div className='col-sm-12 col-md-6 col-lg-4 mb-4'>
            <div className='d-flex justify-content-between pt-4  statsbox px-3'>
              <div className='statsheading'>
                <p className='statSize mb-1 text-muted'>
                  Users Entered Credentials
                </p>
                <h1 className='mb-0'>
                  {allcampaign?.isLoginTrue?.totalClicks}
                </h1>
              </div>
              <div className='text-end'>
                <img className='statsimg' src={targetgroup} alt='' />
              </div>
            </div>
          </div>

          <div className='col-sm-12 col-md-6 col-lg-4 mb-4'>
            <div className='d-flex justify-content-between pt-4 pb-5 statsbox px-3'>
              <div className='statsheading'>
                <p
                  className='statSize mb-1 text-muted'
                  style={{ fontSize: "14" }}
                >
                  Users Clicked Link
                </p>
                <h1 className='mb-0'>
                  {allcampaign?.isLoginFalse?.totalClicks}
                </h1>
              </div>
              <div className='text-end'>
                <img className='statsimg' src={targetuser} alt='' />
              </div>
            </div>
          </div>
        </div>

        <div className='row'>
          <div className='col-md-12 col-lg-6 graphmain'>
            <ChartCardlogin
              title='Users Entered Credentials'
              dataKey='Logins'
              color='#B91C1C'
              data={allcampaign?.isLoginTrue?.weekly}
              selected={selectedCard === 0}
              onClick={() => handleCardClick(0)}
              colornumber={colornumber}
            />
          </div>
          <div className='col-md-12 col-lg-6 graphmain'>
            <ChartCard
              title='Users Clicked'
              dataKey='Clicks'
              color='#15803D'
              data={allcampaign?.isLoginFalse?.weekly}
              selected={selectedCard === 1}
              onClick={() => handleCardClick(1)}
              colornumber={colornumber}
            />
          </div>
        </div>
        <div className='phisingcampaigns'>
          <p>Phishing Simulation Campaigns</p>

          <div style={{ justifyContent: "end" }} className='mainheadingdiv'>
            <div className='d-flex'>
              {selectedCheckboxes.length > 1 && (
                <>
                  {/* <img
                                        alt=""
                                        style={{ cursor: 'pointer' }}
                                        // style={{ position: 'relative', top: '14px', cursor: 'pointer', right: '12px' }}
                                        width={30}
                                        height={30}
                                        src={edit}
                                        onClick={() => {
                                            setEditModalVisible(true)
                                        }}
                                    /> */}
                  <img
                    alt=''
                    style={{ cursor: "pointer" }}
                    //style={{ position: 'relative', top: '14px', cursor: 'pointer', right: '8px' }}
                    width={30}
                    height={30}
                    src={deletebtn}
                    onClick={() => {
                      setModalVisible(true);
                      setDeletecomp(true);
                    }}
                  />
                </>
              )}
            </div>
            <div style={{ paddingLeft: "12px" }} className='searchbox'>
              <Search
                placeholder='Search user....'
                onSearch={onSearch}
                onPressEnter={(e) => onSearch(e.target.value)}
                enterButton
                className='h-[41px] [&>span>input]:h-[41px] [&_.ant-btn]:h-[41px] [&_.ant-btn]:flex [&_.ant-btn]:items-center'
              />
            </div>
          </div>

          <CampaignsTable
            campaigns={allcampaign}
            selectedCheckboxes={selectedCheckboxes}
            onCheckboxChange={handleCheckboxChange}
            oncheckallboxchange={handleSelectAllChange}
          />

          <DeleteModal
            visible={modalVisible}
            onClose={() => setModalVisible(false)}
            currentRoute={currentRoute}
            setNotificationmodal={setDeleteNotificationmodal}
            selectedCampaignId={selectedCheckboxes}
          />

          <DeleteNotification
            visible={deletenotificationmodal}
            onClose={() => setDeleteNotificationmodal(false)}
            currentRoute={currentRoute}
          />

          <EditCampaign
            visible={editmodalVisible}
            onClose={() => setEditModalVisible(false)}
            //    currentRoute={}
            setEditNotificationmodal={setEditNotificationmodal}
          />

          <UpdateNotification
            visible={editnotificationmodal}
            onClose={() => setEditNotificationmodal(false)}
          />
        </div>
      </div>
    </div>
  );
};

export default MyCampaigns;
